package pwgs.ui.scenes.playerslistscene

import visage.core.Navigation


class PlayersListControllerFe(props: PlayersListSceneProps, scene: MPlayersListScene) : APlayersListControllerFe(props, scene) {

    override fun createInitialModel() : PlayersListSceneModel {
        return PlayersListSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onSearchButtonClicked() {
        model.isLoading = true
        render(model)

        call_load()
    }

    fun onPlayerListItemClicked(playerId: String) {
        Navigation.pushLocation("/app/project/${this.props.projectId}/player/$playerId/index.vsg")
    }


}

